/*
 * SS-CUSTOM: backorder-split
 * Tells a customer, before they buy, how much of THEIR quantity is on the shelf
 * and how much is on a container.
 *
 * The variant-level backorder badge only ever answered a yes/no about the
 * variant. Cross the boundary mid-order and it stays silent: 100 real tiles
 * behind 500 inbound reads "In stock" to someone buying 300, and the surprise
 * lands after checkout. That is the complaint this exists to kill.
 *
 * Everything is read from data attributes rendered by ss-backorder-notice, so
 * this never parses stock or dates out of the DOM. Dawn replaces the whole
 * product-info block on a variant change, taking the notice with it, so the
 * paint is driven from an observer rather than bound once to an element that
 * stops existing. Same shape as ss-pdp-quantity.js, deliberately.
 */
(function () {
  'use strict';

  function notice() {
    return document.querySelector('[data-ss-backorder]');
  }

  function quantity() {
    // the main buy box, never the sticky bar or a quick-add card
    var input = document.querySelector(
      '.product-form__quantity input[name="quantity"], product-info input[name="quantity"]'
    );
    return Math.max(1, parseInt(input && input.value, 10) || 1);
  }

  // Plural-safe without pulling in a formatter for two words.
  function unit(n) {
    return n === 1 ? 'is' : 'are';
  }

  function message(physical, qty, eta) {
    if (qty <= physical) return '';
    var waiting = qty - physical;
    if (physical === 0) {
      return 'These arrive ' + eta + '. We hold the full order so everything ships together.';
    }
    return (
      'Only ' +
      physical +
      ' of these ' +
      unit(physical) +
      ' in stock. The other ' +
      waiting +
      ' arrive ' +
      eta +
      ', and we hold the full order so everything ships together.'
    );
  }

  // Every write is guarded, because the observer below watches the same subtree
  // it is writing into. Without the guard a repaint would trigger a repaint.
  function paint() {
    var el = notice();
    if (!el) return;

    // No arrival on this variant, or the attributes were stripped when the
    // customer switched to a colour that has none. Either way there is nothing
    // to promise, and the element has to go quiet rather than keep the last
    // colour's sentence on screen.
    var physical = parseInt(el.dataset.boPhysical, 10);
    var text = el.dataset.boEta && !isNaN(physical) ? message(physical, quantity(), el.dataset.boEta) : '';

    if (el.textContent !== text) el.textContent = text;
    el.classList.toggle('hidden', text === '');
  }

  // Delegated so the quantity input can be replaced without re-binding. Covers
  // typing, the +/- steppers, and the pack helper writing a count in.
  document.addEventListener('input', function (event) {
    if (event.target.closest('.product-form__quantity, product-info')) paint();
  });
  document.addEventListener('change', function (event) {
    if (event.target.closest('.product-form__quantity, product-info')) paint();
  });

  function watch() {
    var root = document.querySelector('product-info');
    if (!root) return;
    new MutationObserver(function () {
      window.requestAnimationFrame(paint);
    }).observe(root, { childList: true, subtree: true });
  }

  function init() {
    paint();
    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
